import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { environment } from 'projects/whocan-app/src/environments/environment';
import { TranslationGeneralService } from '../../../shared/translation/translation.general.service';

/**
 * Von Google vorgeschriebener Hinweistext, wenn das reCAPTCHA-Badge per CSS ausgeblendet wird (styles.scss,
 * `.grecaptcha-badge`). Haengt am Ende des page-containers in whoo-app.component.html und ist damit auf jeder
 * Route sichtbar - auch auf der Vote-Seite und im Embed-Mode, in dem Nav-Bar, Feedback und Cookie-Consent
 * unterdrueckt sind. Ohne konfigurierten Site Key laeuft kein reCAPTCHA, dann bleibt auch der Hinweis weg.
 * Texte: `recaptcha.*` in general.{lang}.dic.json (fuenf Teile, damit die Links in jeder Sprache an der
 * richtigen Stelle sitzen). Workorder app-check-rtdb 2026-10-26, Task 3.
 */
@Component({
    selector: 'recaptcha-notice',
    standalone: true,
    imports: [CommonModule],
    template: `
        <p *ngIf="enabled" class="recaptcha-notice">
            {{ text('before') }}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">{{ text('privacy') }}</a>
            {{ text('between') }}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener">{{ text('terms') }}</a>
            {{ text('after') }}
        </p>
    `,
    styles: [`
        .recaptcha-notice {
            margin: 24px 16px 8px;
            text-align: center;
            font-size: 0.7rem;
            line-height: 1.4;
            color: rgba(0, 0, 0, 0.45);
        }
        .recaptcha-notice a {
            color: inherit;
            text-decoration: underline;
        }
    `],
})
export class RecaptchaNoticeComponent {
    readonly enabled = !!environment.appCheck?.siteKey;

    constructor(private trans: TranslationGeneralService) { }

    text(part: 'before' | 'privacy' | 'between' | 'terms' | 'after'): string {
        return this.trans.translate('recaptcha.' + part);
    }
}
